<template>
  <div class="px-0">
    <vueper-slides
      v-if="items"
      :dragging-distance="50"
      :bullets="false"
      :gap="3"
      :slide-ratio="1 / 4"
      style="background-color: transparent"
      :visible-slides="getNbOfVisibleSlides()"
      @slide="selectSlide('slide', $event)"
      class="no-shadow carousel"
      :fixed-height="dynHeight + 'px'"
      ref="slider"
    >
      <template #arrow-left>
        <v-icon :size="24" :style="{ marginTop: calcArrowMT }" color="white">
          icon-arrow-link-left
        </v-icon>
      </template>

      <template #arrow-right>
        <v-icon :size="24" :style="{ marginTop: calcArrowMT }" color="white">
          icon-arrow-link-right
        </v-icon>
      </template>

      <vueper-slide
        :key="index"
        @click.native="$refs.slider && $refs.slider.goToSlide(index)"
        v-for="(item, index) in items"
      >
        <template #content>
          <div ref="sliderItemContent">
            <fin-archetype-item :archetype="item"
                                :class="{'selected':  active===index, 'slide-active':  active===index}"
                                :display-state="active === index ? 2 : 1"
                                class="d-inline-block"
            />
            <template v-if="active===index">
              <div class="triangle-down"/>

              <div :style="$vuetify.breakpoint.xs ? 'padding-bottom: 76px;' : ''" class="mt-12">
                <template v-if="item.id !== 'INDIVIDUAL'">
                  <v-btn
                    @click="showDetails = true"
                    class="btn-archetype-more mx-2" style="width: 110px"
                    color="white"
                    dark
                    outlined
                  > Mehr erfahren
                  </v-btn>
                  <v-btn @click="storeArchetype({archeType: items[active]})"
                         class="btn-archetype-select mx-2" style="width: 110px"
                         color="white"
                         tile
                  >
                    Auswählen
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn class="mx-2 " color="white" tile @click="showMatrix=true">
                    Zur Zielmatrix
                  </v-btn>
                </template>
              </div>
            </template>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
    <div v-else>
      <fin-error-display error-msg="Ein Fehler ist aufgetreten. Versuch es bitte später nochmals."/>
    </div>

    <!-- show details dialog -->
    <fin-dialog v-if="items && showDetails"
                :fullscreen="$vuetify.breakpoint.xs"
                :maxWidth="1100"
                content-class="archetype-selector-dialog"
                ref="archetypeDetailsDialog"
                dense
                v-model="showDetails">
          <div class="fin-dialog-content">
            <fin-archetype-item :archetype="items[active]"
                                :archetype-classifications="archetypeClassifications"
                                :display-state="3" class="mb-3"
            />
            <div class="triangle-down"></div>

            <v-card-actions class="justify-center pb-12 pt-12" style="background-color: #02073a">
              <!-- <v-icon large style="color: #ffffff">icon-arrow-down</v-icon> -->
              <v-btn @click="storeArchetype({archeType: items[active]})" class="selected-archetype-button"
                     color="white">
                <span class="pl-4 pr-4">
                  Auswählen
                </span>
              </v-btn>
            </v-card-actions>
          </div>
    </fin-dialog>

    <!-- show matrix dialog -->
    <fin-dialog v-if="items"
                dense
                :fullscreen="$vuetify.breakpoint.xs"
                :max-width="900"
                content-class="archetype-selector-dialog"
                v-model="showMatrix">

        <div class="fin-dialog-content">
            <fin-archetype-individual @change="val => this.similarArchetype=val"/>
            <div class="triangle-down-gray"></div>

            <v-card-actions class="justify-center pb-12 pt-12" style="background-color: #02073a">
              <!-- <v-icon large style="color: #ffffff">icon-arrow-down</v-icon> -->
              <v-btn :disabled="saveDisabled" @click="storeArchetype({archeType: items[active]})"
                     class="selected-archetype-button store-button"
                     color="white" light>
            <span class="pl-4 pr-4">
              Auswählen
            </span>
              </v-btn>
            </v-card-actions>
          </div>
    </fin-dialog>
  </div>
</template>

<script>
import {VueperSlide, VueperSlides} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import FinArchetypeItem from '@/components/pages/onboarding/ArchetypeItem'
import FinArchetypeIndividual from './ArchetypeIndividual'
import {mapGetters, mapState} from 'vuex'
import FinErrorDisplay from "@/components/common/ErrorDisplay"

export default {
  name: 'fin-archetype-selector',
  components: {
    FinErrorDisplay,
    FinArchetypeIndividual,
    VueperSlides,
    VueperSlide,
    FinArchetypeItem
  },
  data() {
    return {
      active: 0,
      showDetails: false,
      showMatrix: false,
      similarArchetype: null,
      items: null,
      dynHeight: 400,
    }
  },
  props: {
    value: {}
  },
  computed: {
    ...mapGetters('archetype', ['archetypeFinder']),
    ...mapState('archetype', ['archetypeClassifications']),
    saveDisabled() {
      return !this.similarArchetype?.archeType
    },
    calcArrowMT() {
      let mt = this.dynHeight - 40

      if (this.$vuetify.breakpoint.xs) {
        mt -= 150
      }

      mt += 'px'

      return mt
    }
  },
  mounted() {
      this.items = this.archetypeFinder ? this.archetypeFinder.all : null
      if (this.value.archeType && this.archetypeFinder) {
      const index = this.archetypeFinder.findIndexByArchetypeId(this.value.individual ? 'INDIVIDUAL' : this.value.archeType.id)
      if (index) {
        this.active = index
      }
    }
    this.onPageChange()
  },
  methods: {
    storeArchetype(model) {
      this.showDetails = false
      this.showMatrix = false
      this.$nextTick(() => {
        this.$emit('input', model.archeType.id === 'INDIVIDUAL' ? this.similarArchetype : model)
      })
    },
    selectSlide(eventName, params) {
      this.active = params.currentSlide.index
    },
    getNbOfVisibleSlides() {
      let res = 1
      const bp = this.$vuetify.breakpoint
      if (bp.xl) {
        res = 5
      } else if (bp.lg) {
        res = 4
      } else if (bp.md) {
        res = 3
      } else if (bp.sm) {
        res = 2
      } else {
        res = 1
      }
      return res
    },
    onPageChange() {
      this.$nextTick(() => {
          if (this.$refs.sliderItemContent) {
              this.dynHeight = this.$refs.sliderItemContent[this.active].clientHeight
          }
          if (this.$refs.slider) {
              this.$refs.slider.goToSlide(this.active)
          }
      })
    }
  },
  watch: {
    active() {
      this.onPageChange()
    }
  }
}
</script>

<style lang="scss" scoped>

.selected-archetype-button {
  border-radius: 0;
}

.triangle-down {
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-top: 50px solid white;
  position: absolute;
  clip-path: polygon(50% 35%, 0 0, 100% 0);
  left: 50%;
  margin-left: -25px;
  margin-top: -1px;
}

.triangle-down-gray {
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-top: 50px solid #ededf1;
  position: absolute;
  clip-path: polygon(50% 35%, 0 0, 100% 0);
  left: 50%;
  margin-left: -25px;
  margin-top: -1px;
}

.ie .triangle-down {
  border-top: 20px solid white !important;
  margin-top: -7px !important;
}

.ie .triangle-down-gray {
  border-top: 20px solid #ededf1 !important;
  margin-top: -7px !important;
}

.edge .triangle-down {
  border-top: 20px solid white !important;
}

.edge .triangle-down-gray {
  border-top: 20px solid #ededf1 !important;
}

::v-deep .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f5f5f5 !important;
  opacity: 0.3;
}

.selected {
  background-color: white;
  box-shadow: $fin-color-card-shadow;
  border: solid 1px rgba(0, 0, 0, 0.1);
}

::v-deep .archetype-selector-dialog {
  //overflow-x: hidden !important;
  box-shadow: $fin-color-dialog-shadow;
}

.fin-dialog-content {
  //height: 100%;
  padding: 52px 0 0;
}

::v-deep .vueperslides__arrows--outside .vueperslides__arrow--prev {
  left: 0;
}

::v-deep .vueperslides__arrows--outside .vueperslides__arrow--next {
  right: 0;
}

.carousel {
  font-size: 24px;
}

::v-deep .vueperslides__arrow {
  font-size: 24px;
}

</style>
